(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const filters = root.querySelector('[data-discovery-filters]');
    function navigate(href, clearFilters = false) {
      const target = new URL(href, window.location.origin);
      const current = new URL(window.location.href);
      for (const key of new Set(current.searchParams.keys())) {
        if (key === 'page' || (clearFilters && key.startsWith('filter.'))) continue;
        target.searchParams.delete(key);
        current.searchParams.getAll(key).forEach(value => target.searchParams.append(key, value));
      }
      target.searchParams.delete('page');
      target.hash = 'CollectionProducts';
      window.location.assign(target.href);
    }
    root.querySelectorAll('[data-discovery-filter-link], [data-discovery-reset-link]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault(); navigate(link.href, link.hasAttribute('data-discovery-reset-link'));
      });
    });
    root.querySelectorAll('[data-discovery-filter-select]').forEach(select => {
      select.addEventListener('change', () => navigate(select.value));
      select.hidden = false;
      select.closest('.discovery-filter-group').querySelector('[data-discovery-filter-fallback]').hidden = true;
    });
    root.querySelectorAll('[data-discovery-filter-choices]').forEach(choices => {
      choices.querySelectorAll('[data-discovery-filter-choice]').forEach(input => {
        input.addEventListener('change', () => { if (input.checked) navigate(input.dataset.discoveryUrl); });
      });
      choices.hidden = false;
      choices.closest('.discovery-filter-group').querySelector('[data-discovery-filter-fallback]').hidden = true;
    });
    const form = root.querySelector('[data-discovery-finder]');
    if (!form) return;
    const current = JSON.parse(root.querySelector('[data-discovery-current]').textContent) || [];
    const rawMatches = JSON.parse(root.querySelector('[data-discovery-matches]').textContent) || [];
    const matches = rawMatches.map(row => Array.isArray(row) ? {tags: row, count: 1} : row);
    const selects = Array.from(form.querySelectorAll('[data-discovery-select]'));
    const radios = Array.from(form.querySelectorAll('[data-discovery-kind]'));
    const fields = Array.from(form.querySelectorAll('[data-discovery-field]'));
    const priority = ['system', 'surface', 'format', 'firmness', 'location', 'material', 'preference', 'purchase'];
    fields.sort((a, b) => priority.indexOf(a.dataset.discoveryField) - priority.indexOf(b.dataset.discoveryField));
    fields.forEach(field => field.parentElement.appendChild(field));
    const preserved = current.filter(tag => !tag.startsWith('sb-kind-') && !selects.some(select => tag.startsWith(`sb-${select.name}-`)));
    const any = radios.find(radio => !radio.value);
    if (!radios.some(radio => radio.checked) && any) any.checked = true;
    let showAllKinds = false;
    const more = form.querySelector('[data-discovery-more-kinds]');
    if (radios.some(radio => radio.checked && radio.closest('[data-discovery-extra-kind]'))) {
      showAllKinds = true;
      form.querySelector('.discovery-kind__grid').classList.add('is-expanded');
      if (more) more.setAttribute('aria-expanded', 'true');
    }
    const nativeFiltersActive = Array.from(new URLSearchParams(window.location.search).keys()).some(key => key.startsWith('filter.'));
    function kindValue() { return radios.find(radio => radio.checked)?.value || ''; }
    function selectedTags(exclude) {
      const tags = [...preserved];
      if (kindValue()) tags.push(kindValue());
      selects.forEach(select => { if (select !== exclude && !select.closest('[data-discovery-field]').hidden && select.value) tags.push(select.value); });
      return tags;
    }
    function hasMatch(tags) { return matches.some(row => tags.every(tag => row.tags.includes(tag))); }
    function setStep(index) { root.querySelectorAll('.discovery-steps li').forEach((step, i) => step.classList.toggle('is-current', i === index)); }
    function updateChoices(changedKind = false) {
      const kind = kindValue();
      if (changedKind) selects.forEach(select => select.value = '');
      let visibleFields = 0;
      fields.forEach(field => {
        const select = field.querySelector('select');
        const base = [...preserved, ...(kind ? [kind] : [])];
        const relevant = Array.from(select.options).some(option => option.value && hasMatch([...base, option.value]));
        field.hidden = (!kind && !select.value) || !relevant || (visibleFields >= 3 && !select.value);
        if (!field.hidden) visibleFields++;
        if (field.hidden) select.value = '';
      });
      root.querySelector('[data-discovery-details]').hidden = !fields.some(field => !field.hidden);
      selects.forEach(select => {
        const others = selectedTags(select);
        Array.from(select.options).forEach(option => { option.disabled = !!option.value && !hasMatch([...others, option.value]); });
      });
      const tags = selectedTags();
      const count = matches.filter(row => tags.every(tag => row.tags.includes(tag))).reduce((total, row) => total + row.count, 0);
      const message = root.querySelector('[data-discovery-count]');
      form.querySelector('[data-discovery-submit]').disabled = count === 0;
      if (!count) message.textContent = 'No matches. Remove a detail or choose another product kind.';
      else if (!kind) message.textContent = `${count.toLocaleString()} products to explore. Choose a kind to see relevant details.`;
      else message.textContent = nativeFiltersActive ? 'Your selection is ready. Price and availability filters will also apply.' : `${count.toLocaleString()} matching ${count === 1 ? 'product' : 'products'}`;
      root.querySelector('[data-discovery-status]').textContent = '';
    }
    radios.forEach(radio => radio.addEventListener('change', () => { updateChoices(true);setStep(1); }));
    selects.forEach(select => select.addEventListener('change', () => { updateChoices();setStep(1); }));
    more?.addEventListener('click', () => {
      showAllKinds = !showAllKinds;
      form.querySelector('.discovery-kind__grid').classList.toggle('is-expanded', showAllKinds);
      more.setAttribute('aria-expanded', String(showAllKinds));
      more.innerHTML = showAllKinds ? 'Fewer product kinds <span aria-hidden="true">−</span>' : 'More product kinds <span aria-hidden="true">＋</span>';
    });
    form.querySelector('[data-discovery-reset]').addEventListener('click', () => {
      radios.forEach(radio => radio.checked = !radio.value); selects.forEach(select => select.value = ''); updateChoices();setStep(0);
    });
    form.querySelector('[data-discovery-open-filters]').addEventListener('click', () => {
      if (filters) { filters.open = true; filters.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'}); }
    });
    updateChoices();
    form.addEventListener('submit', event => {
      event.preventDefault();
      const tags = [...new Set(selectedTags())];
      const target = new URL(root.dataset.collectionUrl, window.location.origin);
      if (tags.length) target.pathname += '/' + tags.map(encodeURIComponent).join('+');
      setStep(2); root.querySelector('[data-discovery-status]').textContent = 'Finding matching products…'; navigate(target.href);
    });
  }
  document.querySelectorAll('[data-discovery]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-discovery]').forEach(init));
})();
